<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GsBrdJ/tc-custom/9781452108469.jpg?1740427403605" alt="This image is the cover for the book Modern Sauces"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Modern Sauces
      </h1>
      <p class="bookDescription body article font2">
        <b>“A book you’ll use every day. . . . Think of these sauces as a culinary bag of tricks. I do.” —Dorie Greenspan, James Beard Award winner and <i>New York Times</i>–bestselling author of <i>Around My French Table</i></b><br/>  <br/> Mastering sauces can take your cooking to a whole new level. Award-winning food writer Martha Holmberg was trained at La Varenne, and in <i>Modern Sauces</i> she tackles this sometimes-intimidating subject—using clear, short bites of information and dozens of process photographs to deliver the skill of great sauce-making to every kind of cook, including beginners.<br/>  <br/> More than 100 recipes for sauces range from standards such as béarnaise, hollandaise, and marinara to modern riffs including maple-rum sabayon, caramelized onion coulis, and coconut-curry spiked chocolate sauce. An additional fifty-five recipes use the sauces to their greatest advantage, beautifying pasta, complementing meat or fish, or elevating a cake to brilliant. Organized by ingredient and method, <i>Modern Sauces</i> is both an inspiration and a timeless reference on kitchen technique.<br/>  <br/> “In a clear and encouraging voice, she explains how to season, store, portion, and improvise on classic sauces . . . Easily Holmberg’s best cookbook to date, this uses delicious recipes—like the outstanding Rice Pudding with Cardamom Meringues, Lime Crème Anglaise, and Chunky Mixed-Berry Coulis—to put essential skills in context.” —<i>Library Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martha Holmberg, Ellen Silverman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f44c791